// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationManagement-commonHeaderAdmin-bpUJm {
	position: fixed !important;
}

.PopularLocationManagement-adminLayout-yyPwf {
	padding-top: 64px !important;
}

.PopularLocationManagement-box-E9X68 h2 {
	font-size: 21px;
	font-weight: 600;
}

.PopularLocationManagement-exportLink-QPH4f {
	margin-bottom: -29px;
}

.PopularLocationManagement-blockCenter-CkUhd {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.PopularLocationManagement-panelHeader-Z_MtQ {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.PopularLocationManagement-currencyselect-Ba2mG {
	width: 100%;
	margin-right: 0px;
}

.PopularLocationManagement-panelHeader-Z_MtQ {
	overflow: hidden;
	position: relative;
}

.PopularLocationManagement-mar0-PVXlL {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.PopularLocationManagement-blockCenter-CkUhd {
		padding: 0px;
	}

	.PopularLocationManagement-panelHeader-Z_MtQ {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.PopularLocationManagement-sideAdminPageWrapper-Lht59 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.PopularLocationManagement-panelHeader-Z_MtQ {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.PopularLocationManagement-table-oLwrT {
	display: table;
}

.PopularLocationManagement-tableRow-K_9gi {
	display: table-row;
}

.PopularLocationManagement-tableCell-JBk54 {
	display: table-cell;
	float: none;
}

.PopularLocationManagement-formGroup-NkckD {
	margin-bottom: 6px;
}

.PopularLocationManagement-select-cfMAR {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.PopularLocationManagement-noMargin-gMwdR {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.PopularLocationManagement-exportLink-QPH4f {
	padding-top: 10px;
	padding-right: 10px;
}

.PopularLocationManagement-labelTextNew-cQMTZ {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.PopularLocationManagement-displayInline-wcVmN {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.PopularLocationManagement-btnUPdate-BmN3a {
	display: inline-block;
}

.PopularLocationManagement-btnModalDelete-C64CR {
	display: inline-block;
	margin-left: 15px;
}

.PopularLocationManagement-radioBtn-fQAEs {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.PopularLocationManagement-backgroundImg-G_3ho {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.PopularLocationManagement-btnUPdate-BmN3a {
		display: block;
		margin-bottom: 12px;
	}

	.PopularLocationManagement-btnModalDelete-C64CR {
		display: block;
		margin-left: 0px;
	}

	.PopularLocationManagement-btnWidth-ovles {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.PopularLocationManagement-bannerImageBg-TefHT {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.PopularLocationManagement-bannerDelete-cjKjQ {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.PopularLocationManagement-modalRoot-kEsii {
	padding: 32px;
}

.PopularLocationManagement-modalBorderBottom-eTtZK {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.PopularLocationManagement-logInModalBody-DN6Il {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.PopularLocationManagement-exportSection-r2bgE {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.PopularLocationManagement-exportSectionGridSub-usPmO {
	grid-template-columns: 50% 49% !important;
}

.PopularLocationManagement-exportText-a6qdu {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.PopularLocationManagement-exportLinkImg-Jr2GF {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.PopularLocationManagement-vtrMiddle-lww0t {
	vertical-align: middle;
}

.PopularLocationManagement-exportImg-UUbmO {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.PopularLocationManagement-profileViewlabel-tpBno {
	display: inline-block;
	width: 38%
}

.PopularLocationManagement-profileViewMainContent-gxjD4 {
	display: inline-block;
	width: 62%;
}

.PopularLocationManagement-profileViewMain-fRwCa {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.PopularLocationManagement-profileViewInner-Q7XuD {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.PopularLocationManagement-profileImageSection-I3Tqp {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.PopularLocationManagement-lastviewInner-Aj7Nx {
	padding: 10px;
}

.PopularLocationManagement-whyHostHoriLine-npSpo {
	margin: 30px 0;
}

.PopularLocationManagement-tableGrid-NJKRk {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.PopularLocationManagement-headingContent-bl994 {
	font-size: 18px;
	font-weight: 500;
}

.PopularLocationManagement-refundTextColor-lsOP9 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.PopularLocationManagement-dividerLine-aoE_w {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.PopularLocationManagement-smallContent-HKFEJ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.PopularLocationManagement-sideAdminPageWrapper-Lht59 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.PopularLocationManagement-sideAdminPageWrapper-Lht59 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.PopularLocationManagement-exportSection-r2bgE {
		grid-template-columns: 100%;
	}

	.PopularLocationManagement-exportSectionGridSub-usPmO {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.PopularLocationManagement-profileViewlabel-tpBno {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.PopularLocationManagement-profileViewMainContent-gxjD4 {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.PopularLocationManagement-ChangeToUpperCase-yGpuA {
	text-transform: uppercase
}

.PopularLocationManagement-noBorder-Ufdau {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.PopularLocationManagement-siteAdminHeading-EjOTM {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.PopularLocationManagement-siteAdminSubHeading-CMBko {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.PopularLocationManagement-adminFormDivider-v4uRl {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.PopularLocationManagement-errorMessage-r80XW {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.PopularLocationManagement-panelHeader-Z_MtQ {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.PopularLocationManagement-formGroup-NkckD {
  margin-bottom: 6px;
}

.PopularLocationManagement-select-cfMAR {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.PopularLocationManagement-labelText-DGGoA {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.PopularLocationManagement-space1-rtfjw {
	margin-bottom: 6px !important;
}

.PopularLocationManagement-space2-e9pT4 {
	margin-bottom: 12px !important;
}

.PopularLocationManagement-space3-NcFal {
	margin-bottom: 18px !important;
}

.PopularLocationManagement-space4-L4uZ_ {
	margin-bottom: 24px !important;
}

.PopularLocationManagement-space5-BOOIW {
	margin-bottom: 30px !important;
}

.PopularLocationManagement-space6-z6dGo {
	margin-bottom: 36px !important;
}

.PopularLocationManagement-space7-wEB8W {
	margin-bottom: 42px !important;
}

.PopularLocationManagement-spaceTop8-TNwqW {
	margin-bottom: 48px !important;
}

.PopularLocationManagement-spaceTop1-gqjFy {
	margin-top: 6px !important;
}

.PopularLocationManagement-spaceTop2-ysiLE {
	margin-top: 12px !important;
}

.PopularLocationManagement-spaceTop3-fbYVj {
	margin-top: 18px !important;
}

.PopularLocationManagement-spaceTop4-R55Lb {
	margin-top: 24px !important;
}

.PopularLocationManagement-spaceTop5-CFgcn {
	margin-top: 30px !important;
}

.PopularLocationManagement-spaceTop6-s3g7b {
	margin-top: 36px !important;
}

.PopularLocationManagement-spaceTop7-QhFLp {
	margin-top: 42px !important;
}

.PopularLocationManagement-spaceTop8-TNwqW {
	margin-top: 48px !important;
}

.PopularLocationManagement-noMargin-gMwdR {
	margin: 0px !important;
}

.PopularLocationManagement-padding1-C7pHD {
	padding-bottom: 6px !important;
}

.PopularLocationManagement-padding2-_RMNA {
	padding-bottom: 12px !important;
}

.PopularLocationManagement-padding3-Zi8B3 {
	padding-bottom: 18px !important;
}

.PopularLocationManagement-padding4-iSBLc {
	padding-bottom: 24px !important;
}

.PopularLocationManagement-padding5-wY88i {
	padding-bottom: 30px !important;
}

.PopularLocationManagement-padding6-KN_wt {
	padding-bottom: 36px !important;
}

.PopularLocationManagement-padding7-bQqk6 {
	padding-bottom: 42px !important;
}

.PopularLocationManagement-paddingTop1-vkGir {
	padding-top: 6px !important;
}

.PopularLocationManagement-paddingTop2-tR7b7 {
	padding-top: 12px !important;
}

.PopularLocationManagement-paddingTop3-SOKwB {
	padding-top: 18px !important;
}

.PopularLocationManagement-paddingTop4-ZHfsF {
	padding-top: 24px !important;
}

.PopularLocationManagement-paddingTop5-gNdnP {
	padding-top: 30px !important;
}

.PopularLocationManagement-paddingTop6-OpHjJ {
	padding-top: 36px !important;
}

.PopularLocationManagement-paddingTop7-AgCL9 {
	padding-top: 42px !important;
}

.PopularLocationManagement-noPadding-eeV6t {
	padding: 0px !important;
}

.PopularLocationManagement-textBold-t63pF {
	font-weight: 500 !important;
}

.PopularLocationManagement-textBolder-b32HR {
	font-weight: 700 !important;
}

.PopularLocationManagement-textNormal-gYBQU {
	font-weight: normal !important;
}

.PopularLocationManagement-spaceBottom20-VJhGT {
	margin-bottom: 20px;
}

.PopularLocationManagement-spaceBottom10-dZ1p0 {
	margin-bottom: 10px;
}

.PopularLocationManagement-marginNone-yaVKu {
	margin: 0;
}

.PopularLocationManagement-spaceBottom15-Vp7st {
	margin-bottom: 15px;
}

.PopularLocationManagement-marginTopNone-i6USL {
	margin-top: 0;
}

.PopularLocationManagement-spaceTop11-T2DbQ {
	margin-top: 11px;
}

.PopularLocationManagement-spaceTop21-OJLDD {
	margin-top: 21px;
}

.PopularLocationManagement-spaceTop20-S55wI {
	margin-top: 20px;
}

.PopularLocationManagement-spaceTop10-Wxm8S {
	margin-top: 10px;
}

/*New Design Text Colors */

.PopularLocationManagement-textDarkBlue-QGukd {
	color: rgb(20, 39, 94) !important;
}

.PopularLocationManagement-textLightBlue-MG92f {
	color: rgb(57, 87, 106) !important;
}

.PopularLocationManagement-textLightSandleGreen-SFkoT {
	color: rgb(76, 86, 41) !important;
}

.PopularLocationManagement-textLightBrown-JfjHh {
	color: rgb(115, 79, 33) !important;
}

.PopularLocationManagement-textMediumMaroon-x5dCE {
	color: rgb(87, 37, 51) !important;
}

.PopularLocationManagement-textBrown-oOtbE {
	color: rgb(160, 47, 24) !important;
}

.PopularLocationManagement-textMaroon-VzMCb {
	color: rgb(155, 49, 67) !important;
}

.PopularLocationManagement-textDarkBrown-xsyk7 {
	color: rgb(83, 18, 16) !important;
}

.PopularLocationManagement-textMediumBrown-xOb2d {
	color: rgb(142, 28, 10) !important;
}

.PopularLocationManagement-textSkyBlue-tHVjA {
	color: rgb(37, 117, 141) !important;
}

.PopularLocationManagement-textGray-z_x6m {
	color: rgb(77, 65, 51) !important;
}

.PopularLocationManagement-imageurl-NU3O2 {
    max-width: 378px !important;
    word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/PopularLocation/PopularLocationManagement.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.imageurl {\n    max-width: 378px !important;\n    word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `PopularLocationManagement-commonHeaderAdmin-bpUJm`,
	"adminLayout": `PopularLocationManagement-adminLayout-yyPwf`,
	"box": `PopularLocationManagement-box-E9X68`,
	"exportLink": `PopularLocationManagement-exportLink-QPH4f`,
	"blockCenter": `PopularLocationManagement-blockCenter-CkUhd`,
	"panelHeader": `PopularLocationManagement-panelHeader-Z_MtQ`,
	"currencyselect": `PopularLocationManagement-currencyselect-Ba2mG`,
	"mar0": `PopularLocationManagement-mar0-PVXlL`,
	"sideAdminPageWrapper": `PopularLocationManagement-sideAdminPageWrapper-Lht59`,
	"table": `PopularLocationManagement-table-oLwrT`,
	"tableRow": `PopularLocationManagement-tableRow-K_9gi`,
	"tableCell": `PopularLocationManagement-tableCell-JBk54`,
	"formGroup": `PopularLocationManagement-formGroup-NkckD`,
	"select": `PopularLocationManagement-select-cfMAR`,
	"noMargin": `PopularLocationManagement-noMargin-gMwdR`,
	"labelTextNew": `PopularLocationManagement-labelTextNew-cQMTZ`,
	"displayInline": `PopularLocationManagement-displayInline-wcVmN`,
	"btnUPdate": `PopularLocationManagement-btnUPdate-BmN3a`,
	"btnModalDelete": `PopularLocationManagement-btnModalDelete-C64CR`,
	"radioBtn": `PopularLocationManagement-radioBtn-fQAEs`,
	"backgroundImg": `PopularLocationManagement-backgroundImg-G_3ho`,
	"btnWidth": `PopularLocationManagement-btnWidth-ovles`,
	"bannerImageBg": `PopularLocationManagement-bannerImageBg-TefHT`,
	"bannerDelete": `PopularLocationManagement-bannerDelete-cjKjQ`,
	"modalRoot": `PopularLocationManagement-modalRoot-kEsii`,
	"modalBorderBottom": `PopularLocationManagement-modalBorderBottom-eTtZK`,
	"logInModalBody": `PopularLocationManagement-logInModalBody-DN6Il`,
	"exportSection": `PopularLocationManagement-exportSection-r2bgE`,
	"exportSectionGridSub": `PopularLocationManagement-exportSectionGridSub-usPmO`,
	"exportText": `PopularLocationManagement-exportText-a6qdu`,
	"exportLinkImg": `PopularLocationManagement-exportLinkImg-Jr2GF`,
	"vtrMiddle": `PopularLocationManagement-vtrMiddle-lww0t`,
	"exportImg": `PopularLocationManagement-exportImg-UUbmO`,
	"profileViewlabel": `PopularLocationManagement-profileViewlabel-tpBno`,
	"profileViewMainContent": `PopularLocationManagement-profileViewMainContent-gxjD4`,
	"profileViewMain": `PopularLocationManagement-profileViewMain-fRwCa`,
	"profileViewInner": `PopularLocationManagement-profileViewInner-Q7XuD`,
	"profileImageSection": `PopularLocationManagement-profileImageSection-I3Tqp`,
	"lastviewInner": `PopularLocationManagement-lastviewInner-Aj7Nx`,
	"whyHostHoriLine": `PopularLocationManagement-whyHostHoriLine-npSpo`,
	"tableGrid": `PopularLocationManagement-tableGrid-NJKRk`,
	"headingContent": `PopularLocationManagement-headingContent-bl994`,
	"refundTextColor": `PopularLocationManagement-refundTextColor-lsOP9`,
	"dividerLine": `PopularLocationManagement-dividerLine-aoE_w`,
	"smallContent": `PopularLocationManagement-smallContent-HKFEJ`,
	"ChangeToUpperCase": `PopularLocationManagement-ChangeToUpperCase-yGpuA`,
	"noBorder": `PopularLocationManagement-noBorder-Ufdau`,
	"siteAdminHeading": `PopularLocationManagement-siteAdminHeading-EjOTM`,
	"siteAdminSubHeading": `PopularLocationManagement-siteAdminSubHeading-CMBko`,
	"adminFormDivider": `PopularLocationManagement-adminFormDivider-v4uRl`,
	"errorMessage": `PopularLocationManagement-errorMessage-r80XW`,
	"labelText": `PopularLocationManagement-labelText-DGGoA`,
	"space1": `PopularLocationManagement-space1-rtfjw`,
	"space2": `PopularLocationManagement-space2-e9pT4`,
	"space3": `PopularLocationManagement-space3-NcFal`,
	"space4": `PopularLocationManagement-space4-L4uZ_`,
	"space5": `PopularLocationManagement-space5-BOOIW`,
	"space6": `PopularLocationManagement-space6-z6dGo`,
	"space7": `PopularLocationManagement-space7-wEB8W`,
	"spaceTop8": `PopularLocationManagement-spaceTop8-TNwqW`,
	"spaceTop1": `PopularLocationManagement-spaceTop1-gqjFy`,
	"spaceTop2": `PopularLocationManagement-spaceTop2-ysiLE`,
	"spaceTop3": `PopularLocationManagement-spaceTop3-fbYVj`,
	"spaceTop4": `PopularLocationManagement-spaceTop4-R55Lb`,
	"spaceTop5": `PopularLocationManagement-spaceTop5-CFgcn`,
	"spaceTop6": `PopularLocationManagement-spaceTop6-s3g7b`,
	"spaceTop7": `PopularLocationManagement-spaceTop7-QhFLp`,
	"padding1": `PopularLocationManagement-padding1-C7pHD`,
	"padding2": `PopularLocationManagement-padding2-_RMNA`,
	"padding3": `PopularLocationManagement-padding3-Zi8B3`,
	"padding4": `PopularLocationManagement-padding4-iSBLc`,
	"padding5": `PopularLocationManagement-padding5-wY88i`,
	"padding6": `PopularLocationManagement-padding6-KN_wt`,
	"padding7": `PopularLocationManagement-padding7-bQqk6`,
	"paddingTop1": `PopularLocationManagement-paddingTop1-vkGir`,
	"paddingTop2": `PopularLocationManagement-paddingTop2-tR7b7`,
	"paddingTop3": `PopularLocationManagement-paddingTop3-SOKwB`,
	"paddingTop4": `PopularLocationManagement-paddingTop4-ZHfsF`,
	"paddingTop5": `PopularLocationManagement-paddingTop5-gNdnP`,
	"paddingTop6": `PopularLocationManagement-paddingTop6-OpHjJ`,
	"paddingTop7": `PopularLocationManagement-paddingTop7-AgCL9`,
	"noPadding": `PopularLocationManagement-noPadding-eeV6t`,
	"textBold": `PopularLocationManagement-textBold-t63pF`,
	"textBolder": `PopularLocationManagement-textBolder-b32HR`,
	"textNormal": `PopularLocationManagement-textNormal-gYBQU`,
	"spaceBottom20": `PopularLocationManagement-spaceBottom20-VJhGT`,
	"spaceBottom10": `PopularLocationManagement-spaceBottom10-dZ1p0`,
	"marginNone": `PopularLocationManagement-marginNone-yaVKu`,
	"spaceBottom15": `PopularLocationManagement-spaceBottom15-Vp7st`,
	"marginTopNone": `PopularLocationManagement-marginTopNone-i6USL`,
	"spaceTop11": `PopularLocationManagement-spaceTop11-T2DbQ`,
	"spaceTop21": `PopularLocationManagement-spaceTop21-OJLDD`,
	"spaceTop20": `PopularLocationManagement-spaceTop20-S55wI`,
	"spaceTop10": `PopularLocationManagement-spaceTop10-Wxm8S`,
	"textDarkBlue": `PopularLocationManagement-textDarkBlue-QGukd`,
	"textLightBlue": `PopularLocationManagement-textLightBlue-MG92f`,
	"textLightSandleGreen": `PopularLocationManagement-textLightSandleGreen-SFkoT`,
	"textLightBrown": `PopularLocationManagement-textLightBrown-JfjHh`,
	"textMediumMaroon": `PopularLocationManagement-textMediumMaroon-x5dCE`,
	"textBrown": `PopularLocationManagement-textBrown-oOtbE`,
	"textMaroon": `PopularLocationManagement-textMaroon-VzMCb`,
	"textDarkBrown": `PopularLocationManagement-textDarkBrown-xsyk7`,
	"textMediumBrown": `PopularLocationManagement-textMediumBrown-xOb2d`,
	"textSkyBlue": `PopularLocationManagement-textSkyBlue-tHVjA`,
	"textGray": `PopularLocationManagement-textGray-z_x6m`,
	"imageurl": `PopularLocationManagement-imageurl-NU3O2`
};
module.exports = ___CSS_LOADER_EXPORT___;
